import * as React from 'react';
import { useEffect, useState } from "react";

import { alpha } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import AppNavbar from './components/AppNavbar';
import Header from './components/Header';
import MainGrid from './components/MainGrid';
import SideMenu from './components/SideMenu';
import AppTheme from '../shared-theme/AppTheme';
import {
  chartsCustomizations,
  dataGridCustomizations,
  datePickersCustomizations,
  treeViewCustomizations,
} from './theme/customizations';
// import CenterPane from '../components/CenterPane';
import Scalper from '../pages/Scalper';
import Analytics from '../pages/Analytics';
import Signals from '../pages/Signals';
import RecommendedInstruments from '../pages/RecommendedInstruments';
import { Routes, Route, Link, Navigate, useNavigate } from 'react-router-dom';
import { fetchStats } from "../services/api";
import { getUser, isAuthorized } from "../utils/data";
import StatsDashboard from '../pages/Stats';
import Settings from '../pages/Settings';
import moment from "moment";
import DeploymentDetails from '../pages/Deployment';

const xThemeComponents = {
  ...chartsCustomizations,
  ...dataGridCustomizations,
  ...datePickersCustomizations,
  ...treeViewCustomizations,
};

export default function Dashboard(props) {
  const [stats, setStats] = useState(null);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthorized()) {
      navigate("/login");
      return;
    }

    let currentDate = moment().format("YYYY-MM-DD")
    fetchStats(currentDate)
      .then((response) => setStats(response.data.stats))
      .catch((err) => {
        setError(err.message);
      });
  }, [navigate]);

  return (
    <AppTheme {...props} themeComponents={xThemeComponents}>
      <CssBaseline enableColorScheme />
      <Box sx={{ display: 'flex' }}>
        <SideMenu user={getUser()} />
        <AppNavbar />
        {/* Main content */}
        <Box
          component="main"
          sx={(theme) => ({
            flexGrow: 1,
            backgroundColor: theme.vars
              ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
              : alpha(theme.palette.background.default, 1),
            overflow: 'auto',
          })}
        >
          <Stack
            spacing={2}
            sx={{
              // alignItems: 'center',
              mx: 3,
              pb: 5,
              mt: { xs: 8, md: 0 },
            }}
          >
            <Header page={""} />
            <Routes>
              <Route path="/" element={<StatsDashboard />} />
              {/* <Route path="/" element={<MainGrid stats={stats} error={error} />} /> */}
              <Route path="/scalper" element={<Scalper />} />
              <Route path="/analytics" element={<Analytics />} />
              <Route path="/signals" element={<Signals />} />
              <Route path="/instrument-recommendations" element={<RecommendedInstruments />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/deployments/:deploymentId" element={<DeploymentDetails />} />
              {/* <Route path="/test" element={<CenterPane />} /> */}
            </Routes>
          </Stack>
        </Box>
      </Box>
    </AppTheme>
  );
}
